<template>
    <v-card class="ma-8 pa-8">
        <div class="font-weight-bold text-h6">New Cashier Notes</div>
        <v-divider class="mb-4"></v-divider>
        <div>
            <v-row>
                <v-col cols="12">
                    <v-select
                        :items="employeeName"
                        label="Cashier"
                        prepend-icon="mdi-account"
                        v-model="name"
                    ></v-select>
                </v-col>
                <v-col cols="12">
                    <v-textarea
                        prepend-inner-icon="mdi-comment"
                        v-model="notes"
                        filled
                        label="Notes"
                        clearable
                    ></v-textarea>
                </v-col>
            </v-row>
        </div>
        <v-card elevation="0" class="transparent d-flex justify-space-between">
            <v-btn outlined class="myOrange--text" to="/noteslist">Cancel</v-btn>
            <v-btn class="myGreen white--text" @click="POST_NOTES({ name, notes })">Save</v-btn>
        </v-card>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    data() {
        return {
            notes: "",
            name: "",
            employeeName: [],
        };
    },
    computed: {
        ...mapGetters(["employee"]),
    },
    methods: {
        ...mapActions(["POST_NOTES", "GET_EMPLOYEE"]),
    },
    mounted() {
        this.employeeName = this.employee.map((person) => person.name);
    },
    created() {
        this.GET_EMPLOYEE();
    },
};
</script>
